import { ApiService } from '../services/api_service';
import { DataService } from '../services/data_service';
import DialogWrapper2 from '../core/dialog/dialog_wrapper_v2';
import { CellInfo } from 'react-table-6';
import { i18n } from '../i18n/i18n';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { SchulungRegistrierung } from '../admin/bereiche/unternehmen/SchulungRegistrierung';
import style from './main.less';
import { TriggerService } from '../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';

interface UnternehmenAuswahlProps extends React.ClassAttributes<any> {
    unternehmen: Array<any>;
    registrierungen: Array<any>;
    ber_zuo: Array<any>;
    onSelected: (row: any) => void;
    onListChange: () => void;
}

interface UnternehmenAuswahlState extends React.ClassAttributes<any> {
    showTest: boolean;
    showAddForm: boolean;
    showSchulungRegistrierung: number; // 0 = aus, 1 = Tabelle, 2 = directAddFormular
}

export class UnternehmenAuswahl extends React.Component<UnternehmenAuswahlProps, UnternehmenAuswahlState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showTest: true,
            showAddForm: false,
            showSchulungRegistrierung: 0,
        };
        this.customValidate = this.customValidate.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private anz_reg = -1;
    private mails: any = {};

    componentDidMount(): void {
        this.dataService.loadData(IDs.ENT_USER, {}, { fieldList: 'tid, Mail' }, (data: any) => {
            (this.props.registrierungen || []).forEach((item: any) => {
                this.mails[item.tid] = (item.mail || '').toLowerCase();
            });
            this.dataService.loadData(IDs.ENT_BERATER, {}, { fieldList: 'tid, mail' }, (data2: any) => {
                ((data2 || {})[IDs.ENT_BERATER] || []).forEach((item2: any) => {
                    this.mails[`b${item2.tid}`] = (item2.mail || '').toLowerCase();
                });
            }, IDs.MOD_ETOOL_ADMIN);
            ((data || {})[IDs.ENT_USER] || []).forEach((item: any) => {
                this.mails[`u${item.tid}`] = (item.Mail || '').toLowerCase();
            });
        }, IDs.MOD_LEGACY);
    }

    render(): JSX.Element {
        const { unternehmen, onSelected } = this.props;
        const { showTest } = this.state;
        const customColumns: Array<any> = [
            {
                accessor: 'bezeichnung',
                Header: i18n('Bezeichnung', 'entity.unternehmen'),
                id: 'bezeichnung'
            },
            {
                accessor: 'bereich_key',
                Header: i18n('Bereich', 'entity.unternehmen'),
                id: 'bereich_key'
            },
            {
                accessor: 'ort',
                Header: i18n('Ort', 'entity.unternehmen'),
                id: 'ort'
            },
            {
                accessor: 'plz',
                Header: i18n('PLZ', 'entity.unternehmen'),
                id: 'plz'
            },
            {
                accessor: 'mail',
                Header: i18n('Mailadresse', 'entity.unternehmen'),
                id: 'mail'
            },
            ...((this.apiService.isAdmin() || this.apiService.isBerater()) ? [
                {
                    accessor: 'uuid',
                    Header: 'KMU-ID',
                    id: 'uuid'
                },
                {
                    accessor: 'isTest',
                    Header: i18n('Test-Registrierung', 'entity.unternehmen'),
                    id: 'isTest',
                    filterable: false,
                }
            ] : []),
            {
                accessor: 'lastLogin',
                Header: i18n('Letzter Login', 'entity.unternehmen'),
                id: 'lastLogin',
                filterable: false,
                Cell: (row: CellInfo) => row.original && row.original.lastLogin ? Moment.unix(row.original.lastLogin).format('DD.MM.YYYY') : null
            },
            {
                accessor: 'countLogin',
                Header: i18n('Logins', 'entity.unternehmen'),
                id: 'countLogin',
                filterable: false,
                Cell: (row: CellInfo) => row.original && row.original.countLogin ? row.original.countLogin : null
            }
        ];

        let externalHeaderElements;
        if (this.apiService.isAdmin() || this.apiService.isBerater()) {
            externalHeaderElements = [
                <label
                    className={style.tableUnternehmenBtn}
                    key='label_test'
                >
                    <input
                        type='checkbox'
                        checked={showTest}
                        onChange={(e: any) => this.setState({ showTest: e.target.checked })}
                    />
                    {i18n('Test-Registrierung', 'sys')}
                </label>,
                <label
                    className={style.tableUnternehmenBtn}
                    key='label_add'
                    onClick={() => this.setState({ showAddForm: true })}
                >
                    {i18n('Betrieb anlegen', 'sys')}
                </label>,
                <label
                    className={style.tableUnternehmenBtn}
                    key='label_add_2'
                    onClick={() => this.setState({ showSchulungRegistrierung: 1 })}
                >
                    {i18n('Schulungsveranstaltungen', 'sys')}
                </label>
            ];
        }

        let data = unternehmen;
        if (!showTest) {
            data = data.filter((d: any) => !d.isTest);
        }
        let anz_reg = (this.props.registrierungen && this.props.registrierungen.length) || 0;
        anz_reg += (this.props.ber_zuo && this.props.ber_zuo.length) || 0;
        // console.log('ANZ_REG', this.anz_reg, ' ->', anz_reg, this.props.registrierungen);
        if (anz_reg !== this.anz_reg && anz_reg > 0) {
            if (this.anz_reg > -1) {
                this.props.onListChange();
            }
            this.anz_reg = anz_reg;
        }
        if (unternehmen.length === 0 && anz_reg === 0) {
            return <div style={{ textAlign: 'center' }}>
                <div>Keine Unternehmen vorhanden.</div>
                <div style={{ display: 'flex' }}>
                    <label
                        className={style.tableUnternehmenBtn}
                        key='label_add_1'
                        onClick={() => this.setState({ showAddForm: true })}
                    >
                        {i18n('Betrieb anlegen', 'sys')}
                    </label>
                    <label
                        className={style.tableUnternehmenBtn}
                        key='label_add_2'
                        onClick={() => this.setState({ showSchulungRegistrierung: 2 })}
                    >
                        {i18n('Schulungsveranstaltung anlegen', 'sys')}
                    </label>
                </div>
                {this.state.showAddForm && this.showAddForm()}
                {this.state.showSchulungRegistrierung > 0 && this.renderSchulungRegistrierung()}
            </div>;
        }
        data = data.sort((d1: any, d2: any) => (d1.bezeichnung || '').trim().toLowerCase().localeCompare((d2.bezeichnung || '').trim().toLowerCase()));
        return <div>
            <WFormsTableWrapper
                theme={'tab1'}
                containerId='unternehmen'
                entity={IDs.ENT_UNTERNEHMEN}
                module={IDs.MOD_ETOOL_ADMIN}
                data={data}
                customClass={'Custom-ETA'}
                formLayout={'flowV2'}
                hiddenColumns={['bezeichnung', 'bereich_key', 'ort', 'plz', 'logo', 'strasse']}
                hideExport={true}
                columnWidths={[250]}
                tablePageSize={12}
                customColumns={customColumns}
                customActions={[{
                    id: 'select',
                    label: i18n('Auswählen', 'sys'),
                    key: 'ok',
                    info: i18n('Auswählen', 'sys'),
                    func: onSelected
                }]}
                externalHeaderElements={externalHeaderElements}
                showTableHelp
            />
            <small style={{ display: 'none' }}>Registrierungen: {this.props.registrierungen.length || '?'}</small>
            {this.state.showAddForm && this.showAddForm()}
            {this.state.showSchulungRegistrierung > 0 && this.renderSchulungRegistrierung()}
        </div>;
    }

    showAddForm() {
        return <WFormsTableWrapper
            theme={'tab1'}
            useTheme={1}
            containerId='unternehmen'
            key={'add_reg_form'}
            entity={IDs.ENT_REGISTRIERUNG}
            module={IDs.MOD_ETOOL_ADMIN}
            directEditFormularOf={{ tid: 0 }}
            customClass={'Custom-ETA'}
            validateField={this.customValidate}
            formLayout={'flowV2'}
            onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                if (this.apiService.isBerater()) {
                    const saveItem = {
                        tid: 0,
                        registrierung: saveTid,
                        berater: this.apiService.getUserTid()
                    };
                    this.dataService.saveData(IDs.ENT_BERATERZUORDNUNG, saveItem, null, false, () => {
                        this.triggerService.fire('reload', IDs.ENT_BERATERZUORDNUNG);
                        this.triggerService.fire('reload', IDs.ENT_REGISTRIERUNG);
                        this.setState({ showAddForm: undefined });
                    }, IDs.MOD_ETOOL_ADMIN);
                }
            }}
            callBeforeOnFormSave={(data: any, callback: () => void) => {
                // console.log('callBeforeOnFormSave', data);
                if (this.apiService.isBerater()) {
                    data.berater = this.apiService.getUserTid();
                }
                if (data.mail) {
                    this.apiService.call('checkMailExistence', { mail: data.mail, module: IDs.MOD_ETOOL_ADMIN },
                        (res: string, suc: boolean) => {
                            // console.log(res, suc);
                            if (suc) {
                                if (res === '1') {
                                    alert('E-Mail-Adresse existiert bereits.');
                                } else {
                                    callback();
                                }
                            } else {
                                alert('Server Error');
                            }
                        }
                    );
                }
            }}
            formPreset={{ password: 'auto', password_confirm: 'auto', mail_confirmed: 1, active: 1 }}
            formGroupOrder={[
                {
                    title: i18n('Pflichtangaben', 'sys'),
                    titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                    foldable: false,
                    folded: false,
                    fields: ['unternehmen', 'bereich_key', 'mail']
                },
                {
                    title: i18n('Optionale Angaben', 'sys'),
                    titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                    foldable: true,
                    folded: true,
                    fields: ['name', 'vorname', 'strasse', 'hausnummer', 'ort', 'plz', 'telefon']
                }
            ]}
            onAfterAction={(action: string) => {
                if (action === 'closeForm') {
                    this.setState({ showAddForm: false });
                }
            }}
            validRestriction='stop'
        />;
    }

    customValidate(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        if (key === 'name') {
            if (value && value !== '') {
                const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-]/g, '');
                if (newVal !== value) {
                    onValueChange('name', newVal);
                }
            }
        }
        if (key === 'vorname') {
            if (value && value !== '') {
                const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-\. ]/g, '');
                if (newVal !== value) {
                    onValueChange('vorname', newVal);
                }
            }
        }
        if (key === 'plz') {
            if (value && value !== '') {
                const newVal = value.replace(/[^0-9]/g, '').substr(0, 5);
                if (newVal !== value) {
                    onValueChange('plz', newVal);
                }
            }
        }
        if (key === 'telefon') {
            if (value && value !== '') {
                const newVal = value.replace(/[^0-9+-/]/g, '');
                if (newVal !== value) {
                    onValueChange('telefon', newVal);
                }
            }
        }
        if (key === 'mail') {
            if (value && value !== '') {
                if (
                    value.toLowerCase() !== this.mails[data.values.tid || null]
                    && Object.values(this.mails).indexOf(value.toLowerCase()) > -1
                ) {
                    return 'E-Mail-Adresse existiert bereits.';
                }
            }
        }
        return undefined;
    }

    renderSchulungRegistrierung() {
        if (this.state.showSchulungRegistrierung === 2) {
            return <SchulungRegistrierung
                showDirectAddFormular={true}
                onChange={() => this.triggerService.fire('main_reload', 'getUnternehmenData')}
                onClose={() => this.setState({ showSchulungRegistrierung: 0 })}
            />;
        }
        return <div>
            <DialogWrapper2
                containerId='unternehmen'
                width={-1} // --> wird zu "auto"
                onAfterClose={() => this.setState({ showSchulungRegistrierung: 0 })}
            >
                <div style={{ width: 1200, minHeight: 600 }}>
                    <SchulungRegistrierung
                        onChange={() => this.triggerService.fire('main_reload', 'getUnternehmenData')}
                    />
                </div>
            </DialogWrapper2>
        </div>;
    }
}
